import { Button, Dialog, DialogContent, LinearProgress, Stack, Typography } from '@mui/material';
import StyledCardTitleBar from '../../../../../common/StyledCardTitleBar';
import StyledDialogActions from '../../../../../common/StyledDialogActions';

type Props = {
    open: boolean;
    message: string;
    fetched: number;
    total: number;
    onCancel?: () => void;
};

const SextforceMetricsCampaignsOverviewExportProgressDialog = ({ open, message, fetched, total, onCancel }: Props) => {
    const isIndeterminate = total === 0;
    const progress = total > 0 ? (fetched / total) * 100 : 0;

    return (
        <Dialog open={open} disableEscapeKeyDown onClose={() => {}} maxWidth="sm" fullWidth>
            <StyledCardTitleBar title="Preparing export" />
            <DialogContent>
                <Stack spacing={1.5}>
                    <Typography variant="body2" color="textSecondary">
                        {message}
                    </Typography>
                    <LinearProgress variant={isIndeterminate ? 'indeterminate' : 'determinate'} value={progress} />
                </Stack>
            </DialogContent>
            {onCancel && (
                <StyledDialogActions>
                    <Button onClick={onCancel} color="error">
                        Cancel
                    </Button>
                </StyledDialogActions>
            )}
        </Dialog>
    );
};

export default SextforceMetricsCampaignsOverviewExportProgressDialog;
